import { Button } from 'semantic-ui-react';
import { objectToString } from 'src/components/helpers';

export const ChurchServiceGuestsRowDef = ({
  aditionalinformationUsers,
  inputs,
  paidEvent,
  clickedEvent,
  isEventDayPassed,
  assignGuestToPending,
  showSacarOptions,
}) => {
  return [
    ...(inputs.advanced && showSacarOptions
      ? [
          {
            headerName: 'Sacar',
            field: 'assignPending',
            width: 120,
            sortable: false,
            filter: false,
            cellRenderer: (params) => {
              const hasPaid = !!params.data?.payment?.amount;
              return (
                <Button
                  size="tiny"
                  secondary
                  disabled={!hasPaid}
                  onClick={() => assignGuestToPending(params.data)}
                >
                  Sacar
                </Button>
              );
            },
            flex: 1,
            minWidth: 120,
          },
        ]
      : []),
    {
      headerName: 'Cédula',
      field: 'identification',
      valueGetter: (params) => params.data?.Guest?.identification,
      sortable: true,
      filter: true,
      flex: 1,
      minWidth: 120,
    },
    {
      headerName: 'Nombre',
      field: 'fullName',
      valueGetter: (params) => `${params.data?.Guest?.name} ${params.data?.Guest?.lastName}`,
      sortable: true,
      filter: true,
      flex: 2,
      minWidth: 200,
    },
    {
      headerName: 'Celular',
      field: 'phone',
      valueGetter: (params) => params.data?.Guest?.phone,
      sortable: true,
      filter: true,
      flex: 1.5,
      minWidth: 150,
    },
    ...(!inputs.info && !inputs.payment
      ? [
          {
            headerName: 'Asistió',
            field: 'attended',
            valueGetter: (params) => (params.data?.attended ? 'Sí' : 'No'),
            sortable: true,
            filter: true,
            flex: 1,
            minWidth: 100,
          },
        ]
      : []),
    ...(aditionalinformationUsers.length !== 0
      ? [
          {
            headerName: 'Info Extra',
            field: 'aditionalinformation',
            valueGetter: (params) => {
              if (inputs.info) {
                return objectToString(params.data?.aditionalinformation);
              }
              return Object.keys(params.data?.aditionalinformation || {}).length ? 'Sí' : 'No';
            },
            cellRenderer: (params) => {
              if (inputs.info) {
                return (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: objectToString(params.data?.aditionalinformation),
                    }}
                  />
                );
              }
              return Object.keys(params.data?.aditionalinformation || {}).length ? 'Sí' : 'No';
            },
            sortable: true,
            filter: true,
            flex: 1.5,
            minWidth: 150,
          },
        ]
      : []),
    ...(paidEvent
      ? [
          {
            headerName: 'Info de Pago',
            field: 'payment',
            valueGetter: (params) => {
              if (inputs.payment) {
                return objectToString(params.data?.payment);
              }
              return Object.keys(params.data?.payment || {}).length ? 'Sí' : 'No';
            },
            cellRenderer: (params) => {
              if (inputs.payment) {
                return (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: objectToString(params.data?.payment),
                    }}
                  />
                );
              }
              return Object.keys(params.data?.payment || {}).length ? 'Sí' : 'No';
            },
            sortable: true,
            filter: true,
            flex: 1.5,
            minWidth: 150,
          },
        ]
      : []),
    {
      headerName: 'Ver',
      field: 'actions',
      width: 120,
      sortable: false,
      filter: false,
      cellRenderer: (params) => (
        <Button
          size="tiny"
          onClick={() =>
            window.open(
              `/checkin/servicio?id=${params.data?.Guest?.identification}&eventSN=${clickedEvent?.eventSlugname}&eventId=${clickedEvent?.id}`,
              '_blank'
            )
          }
        >
          Ver
        </Button>
      ),
      flex: 1,
      minWidth: 120,
    },
  ];
};
